import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },

  content: {
    flex: 1,
  },

  infos: {
    flex: 1,
    marginTop: theme.spacing(4.5),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },

  summary: {
    flex: 1,
    justifyContent: 'flex-end',
    marginTop: theme.spacing(6),
  },

  receiveValue: {
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    textAlign: 'right',
  },
}));
